<template>
	<div class="discount-selector">
		<div class="pa-block">
			<h3 class="selector-title">Bénéficiez de remises supplémentaires</h3>
			<div class="pa-block__inner">
				<fieldset>
					<legend>
						Remise abonné : -{{ getSettings.membership_discount }}%
					</legend>
					<p>
						Bénéficiez de -{{ getSettings.membership_discount }}% de remise
						supplémentaire si vous êtes abonné à l'une de nos revues<br />
						<small
							>(L’information Dentaire, Profession Assistant(e) Dentaire,
							L’Orthodontiste, Réalités Cliniques, Stratégie Prothétique,
							Biomatériaux Cliniques).</small
						>
					</p>
					<div
						class="pa-block__row"
						:class="{ active: membership == '0', inactive: membership == '1' }"
					>
						<input
							type="radio"
							name="membership"
							id="membership-notmember"
							value="0"
							v-model="membership"
						/>
						<label for="membership-notmember"> Je ne suis pas abonné </label>
					</div>
					<!-- .pa-block__row -->
					<div
						class="pa-block__row"
						:class="{ active: membership == '1', inactive: membership == '0' }"
					>
						<input
							type="radio"
							name="membership"
							id="membership-member"
							value="1"
							v-model="membership"
						/>
						<label for="membership-member">
							Je suis abonné
							<em v-if="membership == '1'"
								><small
									>La remise s’appliquera automatiquement au moment du paiement
									si votre compte a le statut abonné</small
								></em
							>
						</label>
					</div>
					<!-- .pa-block__row -->
				</fieldset>
				<fieldset>
					<legend class="pb-0">Code de réduction</legend>
					<p>
						Si vous disposez d'un code de réduction, indiquez-le au moment du
						paiement, après avoir validé votre annonce.
					</p>
				</fieldset>
			</div>
			<!-- .pa-block__inner -->
		</div>
		<!-- .pa-block -->
	</div>
	<!-- .discount-selector -->
</template>
<script>
import { mapGetters } from "vuex";

export default {
	name: "membership-selector",
	data: function () {
		return {};
	},
	computed: {
		...mapGetters(["getSettings", "currentMembership"]),
		membership: {
			get() {
				return this.currentMembership;
			},
			set(membership) {
				this.$store.commit("setMembership", membership);
			},
		},
	},
};
</script>
<style lang="scss">
.pb-0 {
	padding-bottom: 0;
}
</style>
